import { LanguageEnum } from '@project-types/LanguageEnum';


export enum CountryEnum {
	cz = 'CZ',
	sk = 'SK',
	de = 'DE',
}


export function isCountryEnum(value: unknown): value is CountryEnum {
	return typeof value === 'string' && Object.values(CountryEnum).includes(value as CountryEnum);
}


export function getAppDefaultCountry(language: LanguageEnum) {
	switch (language) {
		case LanguageEnum.CZ: return CountryEnum.cz;
		case LanguageEnum.SK: return CountryEnum.sk;
		default: return CountryEnum.cz;
	}
}